// Keep the created package ID before building its PDF.
// A retry after a failed build can then update the package instead of duplicating it.
// Let callers distinguish a save whose new package ID is unknown.
export const PACKAGE_ID_MISSING = 'package_id_missing';
export const packageIdMissing = (error) => error?.code === PACKAGE_ID_MISSING;

export async function savePackage({ api, downloadFile, id, body, build = false, fileName, onSavedId }) {
  const response = id
    ? await api.patch(`/bids/packages/${id}`, body)
    : await api.post('/bids/packages', body);
  // A 2xx answer that is not JSON reaches here as {}, so the id may be missing.
  const savedId = response?.package?.id || id;
  if (!savedId) {
    const error = new Error('The package may have been saved, but no package id came back, so no PDF was built. Close this form and open the package from the list before trying again.');
    error.code = PACKAGE_ID_MISSING;
    throw error;
  }
  if (onSavedId) onSavedId(savedId);
  if (build) {
    await downloadFile(`/bids/packages/${savedId}/pdf`, { method: 'POST', fallbackName: fileName });
  }
  return savedId;
}
